// extracted by mini-css-extract-plugin
export default {"container":"LegalData_container__+P1To","link":"LegalData_link__5LXEL"};